import { EmptyResult } from '@package/services/src/Result'

import { GoogleAnalyticsService } from './services'
import {
  AddProductServiceToCartRequest,
  AddProductToCartRequest,
  AddSelectedPaymentRequest,
  CheckoutProcessRequest,
  PageviewRequest,
  PurchasesRequest,
  RemoveProductFromCartRequest,
} from './types'

export default class GoogleAnalyticsInteractor {
  public constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  public pageview(request: PageviewRequest): Promise<EmptyResult> {
    return this.googleAnalyticsService.pageview(request)
  }

  public initCheckoutProcess(
    request: CheckoutProcessRequest
  ): Promise<EmptyResult> {
    return this.googleAnalyticsService.initCheckoutProcess(request)
  }

  public addProductToCart(
    request: AddProductToCartRequest
  ): Promise<EmptyResult> {
    return this.googleAnalyticsService.addProductToCart(request)
  }

  public addSelectedPayment(
    request: AddSelectedPaymentRequest
  ): Promise<EmptyResult> {
    return this.googleAnalyticsService.addSelectedPayment(request)
  }

  public addProductServiceToCart(
    request: AddProductServiceToCartRequest
  ): Promise<EmptyResult> {
    return this.googleAnalyticsService.addProductServiceToCart(request)
  }

  public removeProductFromCart(
    request: RemoveProductFromCartRequest
  ): Promise<EmptyResult> {
    return this.googleAnalyticsService.removeProductFromCart(request)
  }

  public purchases(request: PurchasesRequest): Promise<EmptyResult> {
    return this.googleAnalyticsService.purchases(request)
  }
}
